import { ERROR_CODES } from '../../constants';

const { network_error } = ERROR_CODES;


export const BLOCKING_ERRORS = ['INACTIVE_RECEIVE_REFERENCE_ORDER', 'INACTIVE_RECEIVE_REFERENCE', 'INACTIVE_REFERENCE_LINE_ITEM', 'INACTIVE_REFERENCE_LINE_ITEM_ORDER'];
export const BLOCKING_ERROR_CODES = BLOCKING_ERRORS.reduce((o, c) => { o[c] = c; return o }, {});


export const MODEL_ERROR_CODES: any = {
  multiple_model_ipns_found: 'multiple_model_ipns_found',
  network_error: 'network_error',
  model_not_exists_catalogue: 'model_not_exists_catalogue',
  model_not_available_to_scan: 'model_not_available_to_scan',
  model_not_exists_asn: 'model_not_exists_asn',
  model_in_difference_po_line: 'model_in_difference_po_line',
  model_is_not_expected: 'model_is_not_expected',
  require_manual_po_receive: 'require_manual_po_receive',
  runtime_client_error: 'runtime_client_error',
  ...BLOCKING_ERROR_CODES
};

export const MODEL_ERROR_CODES_MAPPING: any = {
  multiple_model_ipns_found: 'multiple_model_ipns_found',
  network_error,
  model_not_exists_catalogue: 'model id/mpn scanned is not found. Please enter a valid model id/mpn otherwise please ',
  model_not_exists_asn: 'model id/mpn scanned does not exist in the ASN',
  model_not_available_to_scan: 'model id/mpn is not available to scan, ',
  model_in_difference_po_line: 'model is not part of this ASN but found in different PO line',
  model_is_not_expected:
    'The scanned model is not expected as part of this Shipment. Click Continue to proceed with this MPN.',
  INACTIVE_RECEIVE_REFERENCE: 'Shipment or PO is closed or Inactive. ',
  INACTIVE_RECEIVE_REFERENCE_ORDER: 'Underlying PO is closed or cancelled.',
  INACTIVE_REFERENCE_LINE_ITEM: 'Invalid part category.',
  INACTIVE_REFERENCE_LINE_ITEM_ORDER: 'Underlying PO line item is closed or cancelled.',
  runtime_client_error: 'Error occurred while validating the MPN. Please try again. If the problem continues,'
};

export const MPN_NOT_EXPECTED_METRIC = 'MpnNotExpected';
export const IPN_SELECTION_FINANCIAL_RECONCILATION_METRIC = 'IPNSelectionForFinancialReconcilation';
export const NO_MAPPED_IPNS_TOWNSEND_ASN = 'NoMappedIpnsTownsendASN';
export const MPN_NOT_FOUND_METRIC = 'MpnNotFound';
export const MULTIPLE_TOWNSEND_ASN_IPNS_COMMON_LIST = 'MultipleTownSendASNIpnsCommonList';
export const MPN_WARNING_CANCELED = 'MpnWarningCanceled';
export const MPN_IPN_SELECTED_TOWNSEND = 'MpnIpnSelectedTownsend';
export const MPN_IPN_SELECTED_ASN = 'MpnIpnSelectedASN';
export const MPN_IPN_COMBINATION_FOUND = 'MpnIpnSelected';
export const ORDER_NOT_FOUND_METRIC = 'OrderNotFound';
export const PO_CLOSED_METRIC = 'POClosed';
export const LINE_ITEM_CLOSED_METRIC = 'LineItemClosed';
export const ORDER_LINE_ITEM_NOT_FOUND_METRIC = 'OrderLineItemNotFound';
export const NOT_ACTIVE_LINE_ITEM_METRIC = 'NotActiveLineItem';
export const NOT_ACTIVE_REFERENCE_METRIC = 'NotActiveReference';

export const MPN_AUTO_SUGGEST_MESSAGES: any = {
  MPN_NOT_FOUND: "mpn doesnt exists with this combination, proceed with entering all the mpn characters",
  MULTIPLE_MPN_FOUND: "found more than one mpn with the combination, proceed with entering more characters",
  MPN_MINIMUM_CHARACTERS: "Enter at least 3 characters for the MPN auto suggestion"
}


